import { render } from "./LinkPicker.vue?vue&type=template&id=07c74c3e&scoped=true"
import script from "./LinkPicker.vue?vue&type=script&lang=js"
export * from "./LinkPicker.vue?vue&type=script&lang=js"

import "./LinkPicker.vue?vue&type=style&index=0&id=07c74c3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c74c3e"]])

export default __exports__